<template>
	<div
		class="cursor-pointer rounded-[30%] border-2 p-px duration-300"
		:class="[modelValue ? ['border-transparent', bgClass || 'bg-company'] : 'border-black bg-transparent']"
		@click="emit('update:modelValue', !modelValue)"
	>
		<span
			class="text-white m-0 flex h-full w-full transform duration-300"
			:class="{
				'scale-100 opacity-100': modelValue,
				'scale-50 opacity-0': !modelValue
			}"
		>
			<Icon name="mdi:check" class="h-full w-full" />
		</span>
	</div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
	"update:modelValue": [boolean]
}>()
defineProps<{
	modelValue?: boolean
	bgClass?: unknown
}>()
</script>
